export const px = (number: number) => String(number) + 'px'
